import { Routes, Route } from "react-router-dom";
import Home from "../Pages/Home"; 
import Halloween from "../Pages/Halloween";

export default function Rotas() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      
      {/* comentado para remover o banner6 - halloween */}
      {/* <Route path="/halloween" element={<Halloween />} /> */} 
    </Routes>
  );
}
